// import React, { PureComponent } from 'react'
// import classNames from 'classnames'
// import { Menu, Icon } from 'antd'
// import { Link } from 'react-router-dom'
// import { urlToList } from '../_utils/pathTools'
// import { getMenuMatches } from './SiderMenuUtils'
// import { isUrl } from '../_utils/utils'
// import styles from './index.less'
//
// const { SubMenu } = Menu
//
// const getIcon = icon => {
//   if (typeof icon === 'string' && isUrl(icon)) {
//     return <img src={icon} alt='icon' className={styles.icon} />
//   }
//   if (typeof icon === 'string') {
//     return <Icon type={icon} />
//   }
//   return icon
// }
//
// export default class BaseMenu extends PureComponent {
//
//   /**
//    * @memberof SiderMenu
//    */
//   getNavMenuItems = (menusData, parent) => {
//
//     const { user } = this.props
//     let { userType, allowAddingUser, isAdmin } = user
//     // console.log(allowAddingUser)
//
//     if (!menusData) {
//       return []
//     }
//     return menusData
//       .filter(item => item.name && !item.hideInMenu)
//       .map(item => {
//
//         let condition = true
//
//         if (item.authority) {
//           if (!item.authority.includes(userType)) {
//             condition = false
//           }
//         }
//
//         if (item.restrict) {
//           if (!isAdmin) {
//             condition = false
//           }
//         }
//
//         if (!item.dontShowOnMenu && condition) {
//           return this.getSubMenuOrItem(item, parent)
//         }
//       })
//       .filter(item => item)
//   }
//
//   // Get the currently selected menu
//   getSelectedMenuKeys = pathname => {
//     const { flatMenuKeys } = this.props
//     return urlToList(pathname).map(itemPath => getMenuMatches(flatMenuKeys, itemPath).pop())
//   }
//
//   /**
//    * get SubMenu or Item
//    */
//   getSubMenuOrItem = item => {
//     // doc: add hideChildrenInMenu
//     if (item.children && !item.hideChildrenInMenu && item.children.some(child => child.name)) {
//       const { name } = item
//       return (
//         <SubMenu
//           title={
//             item.icon ? (
//               <span>
//                 {getIcon(item.icon)}
//                 <span>{name}</span>
//               </span>
//             ) : (
//               name
//             )
//           }
//           key={item.path}
//         >
//           {this.getNavMenuItems(item.children)}
//         </SubMenu>
//       )
//     }
//     return <Menu.Item key={item.path}>{this.getMenuItemPath(item)}</Menu.Item>
//   }
//
//   /**
//    * Judge whether it is http link.return a or Link
//    * @memberof SiderMenu
//    */
//   getMenuItemPath = item => {
//     const { name } = item
//     const itemPath = this.conversionPath(item.path)
//     const icon = getIcon(item.icon)
//     const { target } = item
//     // Is it a http link
//     if (/^https?:\/\//.test(itemPath)) {
//       return (
//         <a href={itemPath} target={target}>
//           {icon}
//           <span>{name}</span>
//         </a>
//       )
//     }
//     const { location, isMobile, onCollapse } = this.props
//     return (
//       <Link
//         to={itemPath}
//         target={target}
//         replace={itemPath === location.pathname}
//         onClick={
//           isMobile
//             ? () => {
//               onCollapse(true)
//             }
//             : undefined
//         }
//       >
//         {icon}
//         <span>{name}</span>
//       </Link>
//     )
//   }
//
//   conversionPath = path => {
//     if (path && path.indexOf('http') === 0) {
//       return path
//     }
//     return `/${path || ''}`.replace(/\/+/g, '/')
//   }
//
//   render() {
//     const {
//       openKeys,
//       navTheme,
//       mode,
//       location: { pathname },
//       className,
//       collapsed
//     } = this.props
//     // if pathname can't match, use the nearest parent's key
//     let selectedKeys = this.getSelectedMenuKeys(pathname)
//     if (!selectedKeys.length && openKeys) {
//       selectedKeys = [openKeys[openKeys.length - 1]]
//     }
//     let props = {}
//     if (openKeys && !collapsed) {
//       props = {
//         openKeys: openKeys.length === 0 ? [...selectedKeys] : openKeys
//       }
//     }
//     const { handleOpenChange, style, menuData } = this.props
//     const cls = classNames(className, {
//       'top-nav-menu': mode === 'horizontal'
//     })
//
//     return (
//       <Menu
//         key='Menu'
//         mode={mode}
//         theme={navTheme}
//         onOpenChange={handleOpenChange}
//         selectedKeys={selectedKeys}
//         style={style}
//         className={cls}
//         {...props}
//       >
//         {this.getNavMenuItems(menuData)}
//       </Menu>
//     )
//   }
// }

import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Menu, Icon } from 'antd'
import { Link } from 'react-router-dom'
import { urlToList } from '../_utils/pathTools'
import { getMenuMatches } from './SiderMenuUtils'
import { isUrl } from '../_utils/utils'
import { getSidebarNavIcon } from '../../containers/newAdminDashboard/components/Icons'
import styles from './index.less'

const { SubMenu } = Menu

const getIcon = (icon, item, isSubItem = false) => {
  if (isSubItem) {
    return null
  }

  if (typeof icon === 'string' && isUrl(icon)) {
    return <img src={icon} alt="icon" className={styles.icon} />
  }

  const lookupKey = (item && (item.key || item.path || item.name)) || icon
  const customSvg = getSidebarNavIcon(lookupKey, item)
  if (customSvg) {
    return customSvg
  }

  if (typeof icon === 'string' && icon) {
    return <Icon type={icon} />
  }

  return <Icon type="file-text" />
}

export default class BaseMenu extends PureComponent {
  getNavMenuItems = (menusData, parent) => {
    const { user } = this.props
    let { userType, allowAddingUser, isAdmin } = user

    if (!menusData) {
      return []
    }
    return menusData
      .filter(item => item.name && !item.hideInMenu)
      .map(item => {
        let condition = true

        if (item.authority) {
          if (!item.authority.includes(userType)) {
            condition = false
          }
        }

        if (item.restrict) {
          if (!isAdmin) {
            condition = false
          }
        }

        if (!item.dontShowOnMenu && condition) {
          return this.getSubMenuOrItem(item, parent)
        }
      })
      .filter(item => item)
  }

  getSelectedMenuKeys = pathname => {
    const { flatMenuKeys } = this.props
    return urlToList(pathname).map(itemPath => getMenuMatches(flatMenuKeys, itemPath).pop())
  }

  getSubMenuOrItem = (item, parent) => {
    const isSubItem = !!parent
    const icon = getIcon(item.icon, item, isSubItem)
    const uniqueKey = item.path || item.key

    if (item.children && !item.hideChildrenInMenu && item.children.some(child => child.name)) {
      const { name } = item
      return (
        <SubMenu
          title={
            <span>
              {icon ? <span className="anticon">{icon}</span> : null}
              <span>{name}</span>
            </span>
          }
          key={uniqueKey}
        >
          {this.getNavMenuItems(item.children, item)}
        </SubMenu>
      )
    }
    return <Menu.Item key={uniqueKey}>{this.getMenuItemPath(item, isSubItem)}</Menu.Item>
  }

  getMenuItemPath = (item, isSubItem = false) => {
    const { name } = item
    const itemPath = this.conversionPath(item.path)
    const icon = getIcon(item.icon, item, isSubItem)
    const { target } = item

    if (/^https?:\/\//.test(itemPath)) {
      return (
        <a href={itemPath} target={target}>
          {icon ? <span className="anticon">{icon}</span> : null}
          <span>{name}</span>
        </a>
      )
    }
    const { location, isMobile, onCollapse } = this.props
    return (
      <Link
        to={itemPath}
        target={target}
        replace={itemPath === location.pathname}
        onClick={
          isMobile
            ? () => {
              onCollapse(true)
            }
            : undefined
        }
      >
        {icon ? <span className="anticon">{icon}</span> : null}
        <span>{name}</span>
      </Link>
    )
  }

  conversionPath = path => {
    if (path && path.indexOf('http') === 0) {
      return path
    }
    return `/${path || ''}`.replace(/\/+/g, '/')
  }

  render() {
    const {
      openKeys,
      navTheme,
      mode,
      location: { pathname },
      className,
      collapsed
    } = this.props

    let selectedKeys = this.getSelectedMenuKeys(pathname)
    if (!selectedKeys.length && openKeys) {
      selectedKeys = [openKeys[openKeys.length - 1]]
    }
    let props = {}
    if (openKeys && !collapsed) {
      props = {
        openKeys: openKeys.length === 0 ? [...selectedKeys] : openKeys
      }
    }
    const { handleOpenChange, style, menuData } = this.props
    const cls = classNames(className, {
      'top-nav-menu': mode === 'horizontal'
    })

    return (
      <Menu
        key="Menu"
        mode={mode}
        theme={navTheme}
        onOpenChange={handleOpenChange}
        selectedKeys={selectedKeys}
        style={style}
        className={cls}
        {...props}
      >
        {this.getNavMenuItems(menuData)}
      </Menu>
    )
  }
}
